<template>
  <div class="giveaway">
    <div class="wrapper">
      <h3>{{ giveaway.name }}</h3>
      <Time :endDate="endDate" v-if="!giveaway.winner?.user" />
    </div>
    <div class="user-side" v-if="giveaway.winner?.user">
      <div class="avatar-wrapper" v-bind="$attrs">
        <div class="avatar winner">
          <img
            :src="giveaway.winner.user.avatar"
            :alt="giveaway.winner.user.name"
          />
          <div class="winner">
            <span> WINNER </span>
          </div>
        </div>
      </div>
      <p>{{ giveaway.winner?.user.name }}</p>
    </div>
    <Button
      v-else
      type="primary__white"
      style="width: 156px; letter-spacing: -0.4px"
      :disabled="giveaway.is_participant"
      @click="$router.push({ name: 'giveaways' })"
      >{{ buttonText }}</Button
    >
    <img class="hover-image" :src="giveaway.item.thumbnail" alt="img" />
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue"
import Time from "@/components/home/desktop/Giveaways/Time.vue"
import giveawayMixin from "../../mixins/giveawayMixin"

export default defineComponent({
  name: "GiveawayItem",
  components: { Time },
  mixins: [giveawayMixin],
})
</script>

<style lang="scss" scoped>
.giveaway {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-width: 204px;
  max-width: 400px;
  flex-grow: 1;
  height: 144px;
  padding: 24px;
  gap: 24px;
  position: relative;

  :not(img) {
    z-index: 1;
  }

  .user-side {
    width: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 15px;
    .avatar-wrapper {
      p {
        font-family: "Montserrat";
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 16px;
        color: #ffffff;
      }
      width: 48px;
      height: 48px;
      position: relative;
      .avatar {
        img {
          width: 100%;
          height: 100%;
          position: relative;
          z-index: 1;
          background: rgb(47 49 53);
          border-radius: 50%;
        }
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.04);
        border-radius: 50%;

        &.winner {
          z-index: 1;
          overflow: hidden; /* ensures ::after doesn't leak outside */
          &::after {
            content: "";
            position: absolute;
            z-index: 0;
            top: -2px;
            left: -2px;
            right: -2px;
            bottom: -2px;
            background: linear-gradient(135deg, #ffaa00 50.81%, #ff5e00 100%);
            border-radius: inherit;
          }
        }
      }

      div.winner:not(.avatar) {
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 2px;
        gap: 10px;
        position: absolute;
        width: 81px;
        height: 20px;
        bottom: -12px;
        background: #212429;
        border-radius: 6px;
        left: calc(50% - 40.5px);
        overflow: hidden; /* ensures ::after doesn't leak outside */
        z-index: 1;

        &::after {
          content: "";
          z-index: 0;
          background: linear-gradient(135deg, #ffaa00 50.81%, #ff5e00 100%);
          border-radius: inherit;
          position: absolute;
          inset: 0;
          padding: 1px;
          -webkit-mask: linear-gradient(#000 0 0) content-box,
            linear-gradient(#000 0 0);
          mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
          -webkit-mask-composite: xor;
          mask-composite: exclude;
        }

        span {
          font-family: "Druk Text Wide Cyr";
          font-weight: 900;
          font-size: 12px;
          line-height: 12px;
          z-index: 1;

          background: linear-gradient(135deg, #ffaa00 50.81%, #ff5e00 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }
      }

      img.side {
        position: absolute;
        width: 16px;
        height: 16px;
        top: -4px;
        right: -4px;
        z-index: 1;
      }
    }

    span {
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: -0.4px;
      background: linear-gradient(
        135deg,
        #00ffaa 0%,
        #4579f5 51.65%,
        #9c42f5 99.83%
      );
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      cursor: pointer;
    }
  }

  &:hover {
    .hover-image {
      transform: rotate(0deg) scale(1.5) translateX(-10px) translateY(-24px);
    }
  }
  .hover-image {
    position: absolute;
    width: 231px;
    height: 231px;
    right: -100px;
    top: -34.88px;
    transform: rotate(-9.27deg);
    transition: 1s transform;
  }

  background: var(--black-gradient);
  box-shadow: var(--black-gradient);
  border-radius: 24px;

  .wrapper {
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: start;
    h3 {
      font-family: Montserrat;
      font-weight: 700;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: -0.4px;
    }
  }
}
</style>
